export default function makePath(locale, component, location) {
  const arrayLocation = location.pathname.split('/');
  let componentName = '/';

  if (component === '') {
    componentName = '';
  } else {
    componentName += component;
  }
  if (arrayLocation.length > 3) {
    for (let i = 3; i < arrayLocation.length; i += 1) {
      componentName += `/${arrayLocation[i]}`;
    }
  }

  return `/${locale}${componentName}`;
}
